import { render, staticRenderFns } from "./BaseCardSubHeadingSolution.vue?vue&type=template&id=26422676&scoped=true&"
import script from "./BaseCardSubHeadingSolution.vue?vue&type=script&lang=ts&"
export * from "./BaseCardSubHeadingSolution.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardSubHeadingSolution.vue?vue&type=style&index=0&id=26422676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26422676",
  null
  
)

export default component.exports